<template>
  <v-container fluid>
    <div>
      <fieldset>
        <legend>
          <div class="text-body-1 font-weight-bold">Informations client</div>
        </legend>
        <v-divider />

        <!-- ---------------------------- -->
        <!-- Commande pour agent lui même -->
        <!-- ---------------------------- -->

        <v-col
          v-if="
            $store.getters.commande.statutCommande != 'BROUILLON' ||
              $store.getters.commande.statutCommande === 'undefined'
          "
          cols="10"
          sm="10"
        >
          <v-container pa-0 pl-5>
            <v-layout row wrap>
              <v-checkbox
                v-model="$store.getters.commande.commandeAgent"
                class="shrink mr-2"
                :disabled="$store.getters.commande.commandeAgent == true"
                @change="copierPourLuiMeme()"
              />
              <div class="mt-6">
                Cette commande est pour moi-même (les informations client
                s'afficheront automatiquement)
              </div>
            </v-layout>
          </v-container>
        </v-col>

        <!-- ------------------------- -->
        <!-- Rechercher client existant-->
        <!-- ------------------------- -->
        <v-card v-if="$store.getters.commande.commandeAgent == false" class="pa-3">
          <v-row class="pl-5">
            <v-col cols="10" sm="5" class="pa-0">
              <div class="pb-3">Sélectionner un client par numéro ou par nom dans la liste:</div>
              <v-autocomplete
                v-model="clientSelect"
                :items="items"
                :loading="loading"
                :search-input.sync="recherche"
                class="text-caption pa-0"
                hide-no-data
                hide-selected
                dense
                item-text="infoClient"
                label="Sélectionnez"
                prepend-icon="mdi-database-search"
                return-object
                @change="selectionnerClient"
              />
            </v-col>

            <v-col cols="5" sm="1" class="pa-0">
              <div class="font-weight-bold font-size: 17px pl-8 pt-4">Ou</div>
            </v-col>

            <!-- ------------------------- -->
            <!-- Rechercher nouveau client -->
            <!-- ------------------------- -->
            <v-col cols="10" sm="5" class="pa-0">
              <div class>Dans le cas d'un nouveau client, sélectionner un type de client</div>
              <v-select
                v-model.trim="typeClientSelectionne"
                :items="typeClientsAutorise"
                label="Sélectionnez"
                item-text="1"
                item-value="0"
                class="text-caption pa-0"
                dense
                height="40"
                clearable
                single-line
                hide-no-data
                @change="majInfosDestinataire()"
              />

              <v-layout
                v-if="
                  afficherBoiteRechercheClient == true &&
                    $store.getters.commande.destinataireClient.typeClient !=
                      'PART_USAGE_PERSONNEL' &&
                    $store.getters.commande.destinataireClient.typeClient !=
                      'LIEU_DE_CULTE'
                "
                pl-
              >
                <v-row class="pl-5">
                  <v-col cols="8" sm="8" class="font-weight-bold pa-0">
                    <v-text-field
                      v-model.trim="noClientJDE"
                      clearable
                      label="Rechercher un nouveau client par no"
                      placeholder="Saisir un numéro"
                      outlined
                      maxlength="10"
                      @keyup.enter="validerAvantRechercheCarnetAdresse()"
                    />
                  </v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    <div class="pl-4 pt-2">
                      <v-btn
                        medium
                        color="primary"
                        style="text-transform: none;"
                        @click="validerAvantRechercheCarnetAdresse()"
                      >Rechercher</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-layout>
            </v-col>
          </v-row>
        </v-card>

        <v-flex xs8 pl-3 pt-4 />

        <v-layout>
          <v-flex class="font-weight-bold" pl-5 md10>
            <div style="color:red">{{ messageAgentNonAutorise }}</div>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex class="font-weight-bold" pl-5 md10>
            <div style="color:red">{{ messageClientExisteListeAgent }}</div>
          </v-flex>
        </v-layout>

        <!-- ------------------------------------------ -->
        <!--Type de client particulier ou lieu de culte -->
        <!-- ------------------------------------------ -->

        <v-card class="pa-3">
          <v-layout>
            <v-flex xs10>
              <v-layout
                v-if="
                  $store.getters.commande.destinataireClient.typeClient ==
                    'PART_USAGE_PERSONNEL' ||
                    $store.getters.commande.destinataireClient.typeClient ==
                      'LIEU_DE_CULTE'
                "
                ml-4
              >
                <!-- ------------------  ->
                <!   Colonne de gauche-->
                <!-- ------------------ -->
                <v-flex xs8>
                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md4>No de client</v-flex>
                    <v-flex md8>
                      <v-text-field
                        v-model.trim="
                          $store.getters.commande.destinataireClient.noClientJDE
                        "
                        v-mask="'########'"
                        :disabled="champNoClientParticulierLectureSeul == true"
                        clearable
                        @change="
                          rechercherClientExisteListeAgent(
                            $store.getters.commande.destinataireClient
                              .noClientJDE
                          )
                        "
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md4>Nom du client</v-flex>
                    <v-flex md8>
                      <v-text-field
                        v-model.trim="nomParticulier"
                        clearable
                        maxlength="128"
                        @change="submit"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md4>Nom du contact</v-flex>
                    <v-flex md8>
                      <v-text-field
                        v-model.trim="nomContactParticulier"
                        clearable
                        maxlength="128"
                        @change="submit"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md4>Courriel du contact</v-flex>
                    <v-flex md8>
                      <v-text-field
                        v-model.trim="courrielContactParticulier"
                        class="pr-3"
                        :error-messages="courrielContactParticulierErrors"
                        maxlength="128"
                        @change="submit"
                        @input="$v.courrielContactParticulier.$touch()"
                        @blur="$v.courrielContactParticulier.$touch()"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- ------------------ -->
                <!-- Colonne de droite  -->
                <!-- ------------------ -->
                <v-flex xs8 pl-9>
                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md3>Adresse</v-flex>
                    <v-flex md10>
                      <v-text-field
                        v-model.trim="adresseParticulier"
                        clearable
                        maxlength="128"
                        @change="submit"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md3>Ville</v-flex>
                    <v-flex md10>
                      <v-text-field
                        v-model="villeParticulier"
                        clearable
                        maxlength="128"
                        @change="submit"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md3>Code postal</v-flex>
                    <v-flex md10>
                      <v-text-field
                        v-model="codePostalParticulier"
                        v-mask="'SXS XSX'"
                        clearable
                        @change="submit"
                      />
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex class="font-weight-bold" pt-5 md4>No téléphone</v-flex>
                    <v-flex md5>
                      <v-text-field
                        v-model="noTelephoneParticulier"
                        v-mask="'(###) ###-####'"
                        clearable
                        @change="submit"
                      />
                    </v-flex>
                    <v-flex class="font-weight-bold" pt-5 pl-5 md3>Poste</v-flex>

                    <v-flex md5>
                      <v-text-field
                        v-model="posteTelephoneParticulier"
                        clearable
                        maxlength="12"
                        @change="submit"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!-- ------------------------------------------ -->
              <!--     Titulaire de permis et agents          -->
              <!-- ------------------------------------------ -->

              <v-card-text
                v-if="
                  $store.getters.commande.destinataireClient.typeClient !=
                    'PART_USAGE_PERSONNEL' &&
                    $store.getters.commande.destinataireClient.typeClient !=
                      'LIEU_DE_CULTE'
                "
              >
                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.noClientJDE !=
                      null
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Type de client</v-col>
                  <v-col
                    v-if="
                      typesClientJDE.get(
                        $store.getters.commande.destinataireClient.typeClient
                      ) != null
                    "
                    cols="5"
                    sm="4"
                    class="pa-0"
                  >
                    {{
                    typesClientJDE.get(
                    $store.getters.commande.destinataireClient.typeClient
                    )
                    }}
                  </v-col>

                  <v-col v-else cols="5" sm="4" class="pa-0">
                    {{
                    typeClient.get(
                    $store.getters.commande.destinataireClient.typeClient
                    )
                    }}
                  </v-col>
                </v-row>

                <v-row v-if="$store.getters.commande.destinataireClient.noClientJDE" class="pl-5">
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">No de client</v-col>
                  <v-col
                    cols="5"
                    sm="4"
                    class="pa-0"
                  >{{ $store.getters.commande.destinataireClient.noClientJDE }}</v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.infosClientJDE !=
                      null
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Nom du client</v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClient.infosClientJDE
                    .nom
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.nomResponsable
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Nom du responsable</v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClient.nomResponsable
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.infosClientJDE !=
                      null
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Adresse</v-col>
                  <v-col cols="5" sm="6" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClient.infosClientJDE
                    .adresse
                    }}
                    {{
                    $store.getters.commande.destinataireClient.infosClientJDE
                    .ville
                    }}
                    {{
                    $store.getters.commande.destinataireClient.infosClientJDE
                    .codePostal
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.adresseCourriel
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Courriel</v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClient.adresseCourriel
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient
                      .noTelephoneBureau1 != null
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Téléphone bureau 1</v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClient
                    .noTelephoneBureau1
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient
                      .noTelephoneBureau2
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Téléphone bureau 2</v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClient
                    .noTelephoneBureau2
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.noTelephoneAutre
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Téléphone autre</v-col>
                  <v-col cols="5" sm="4" class="pa-0">
                    {{
                    $store.getters.commande.destinataireClientataire
                    .noTelephoneAutre
                    }}
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.typeClient !=
                      'PART_USAGE_PERSONNEL' &&
                      $store.getters.commande.destinataireClient.typeClient !=
                        'LIEU_DE_CULTE' &&
                      $store.getters.destinataireClient.noClientJDE != null
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Nom du contact</v-col>
                  <v-col cols="5" sm="6" class="pa-0">{{ nomContact }}</v-col>
                </v-row>

                <v-row
                  v-if="
                    $store.getters.commande.destinataireClient.typeClient !=
                      'PART_USAGE_PERSONNEL' &&
                      $store.getters.commande.destinataireClient.typeClient !=
                        'LIEU_DE_CULTE' &&
                      $store.getters.destinataireClient.noClientJDE != null
                  "
                  class="pl-5"
                >
                  <v-col cols="5" sm="2" class="font-weight-bold pa-0">Courriel du contact</v-col>
                  <v-col cols="5" sm="6" class="pa-0">{{ courrielContact }}</v-col>
                </v-row>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </fieldset>
    </div>
  </v-container>
</template>

<script>
import { typesClient, typesClientJDE } from '@/plugins/enums'
import { mask } from 'vue-the-mask'
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'

export default {
  name: 'StepDestinataire',
  directives: { mask },
  mixins: [validationMixin],

  data() {
    return {
      clientSelect: null,
      recherche: null,
      typeClientsAutorise: [],
      typeClientSelectionne: null,
      clientRecherche: [],
      noClientJDE: null,
      nomContact: null,
      courrielContact: null,
      champNoClientParticulierLectureSeul: false,

      nomParticulier: null,
      nomContactParticulier: null,
      courrielContactParticulier: null,
      adresseParticulier: null,
      villeParticulier: null,
      codePostalParticulier: null,
      noTelephoneParticulier: null,
      posteTelephoneParticulier: null,

      clientExistePourAgent: false,
      listeClientPourAgent: [],
      messageAgentNonAutorise: null,
      messageClientExisteListeAgent: null,
      filtre: null,
      loading: false,
      afficherBoiteRechercheClient: true,
      idClientPourRecherche: null,
      sending: false,
      headers: [
        { text: 'No de client', value: 'noClientJDE', width: '200px' },
        { text: 'Nom', value: 'nom' },
      ],
    }
  },
  computed: {
    agentConnecte: function () {
      return this.$store.getters.agentConnecte
    },
    agentConnecteInfosJDE: function () {
      return this.$store.getters.agentConnecteInfosJDE
    },
    client: function () {
      return this.$store.getters.client
    },

    typesClientJDE: function () {
      return typesClientJDE
    },
    arrayTypesClientJDE: function () {
      return Array.from(typesClientJDE)
    },
    typeClient: function () {
      return typesClient
    },
    typesClient: function () {
      return Array.from(typesClient)
    },
    typesClientCommande: function () {
      return typesClient
    },
    demandeur: function () {
      return this.$store.getters.commande.demandeur
    },

    items() {
      return this.clientRecherche.map((p) => {
        const infoClient = p.noClientJDE + ' ' + p.nom
        return Object.assign({}, p, { infoClient })
      })
    },
    courrielContactErrors() {
      const errors = []
      if (!this.$v.courrielContact.$dirty) return errors
      !this.$v.courrielContact.required && errors.push('Champ obligatoire')
      !this.$v.courrielContact.email &&
        errors.push("Le format n'est pas valide")
      return errors
    },
    courrielContactParticulierErrors() {
      const errors = []
      if (!this.$v.courrielContactParticulier.$dirty) return errors
      !this.$v.courrielContactParticulier.email &&
        errors.push("Le format n'est pas valide")
      return errors
    },
    nomContactErrors() {
      const errors = []
      if (!this.$v.nomContact.$dirty) return errors
      !this.$v.nomContact.required && errors.push(this.$t('msg_obligatoire'))
      return errors
    },
  },

  validations: {
    nomContact: {
      required,
    },
    courrielContact: {
      required,
      email,
    },
    courrielContactParticulier: {
      email,
    },
  },

  watch: {
    recherche(val) {
      if (val == null || val == '') {
        this.clientRecherche = []
      } else {
        this.clientRecherche = this.listeClientPourAgent
      }
    },

    '$store.getters.commande.destinataireClient': function (
      destinataireClient
    ) {
      console.log('Dans le watch du destinataire ')

      this.messageClientExisteListeAgent = ''

      if (this.$store.getters.commande.commandeAgent == true) {
        console.log('step destinataire : commande fait pour agent lui-même')

        //this.$store.getters.commande.destinataireClient.isClient = false
        this.$store.getters.commande.demandeur.isClient = false

        this.noClientJDE = this.$store.getters.commande.demandeur.noClientJDE
      } else {
        // commande pour un client

        console.log('step destinataire : commande pour un client ')

        if (this.$store.getters.commande.destinataireClient != null) {
          this.nomContact =
            this.$store.getters.commande.destinataireClient.nomContact
          this.courrielContact =
            this.$store.getters.commande.destinataireClient.courrielContact

          if (
            this.$store.getters.commande.destinataireClient.typeClient ==
              'PART_USAGE_PERSONNEL' ||
            this.$store.getters.commande.destinataireClient.typeClient ==
              'LIEU_DE_CULTE'
          ) {
            this.nomParticulier =
              this.$store.getters.commande.destinataireClient.nom
            this.nomContactParticulier =
              this.$store.getters.commande.destinataireClient.nomContact
            this.courrielContactParticulier =
              this.$store.getters.commande.destinataireClient.courrielContact
            this.adresseParticulier =
              this.$store.getters.commande.destinataireClient.adresse
            this.villeParticulier =
              this.$store.getters.commande.destinataireClient.ville
            this.codePostalParticulier =
              this.$store.getters.commande.destinataireClient.codePostal
            this.noTelephoneParticulier =
              this.$store.getters.commande.destinataireClient.noTelephone
            this.posteTelephoneParticulier =
              this.$store.getters.commande.destinataireClient.posteTelephone

            if (
              this.$store.getters.commande.destinataireClient.noClientJDE !=
                null &&
              this.$store.getters.commande.destinataireClient.nom != null
            ) {
              this.champNoClientParticulierLectureSeul = true
            }
          }
        }

        if (this.$store.getters.commande.destinataireClient == null) {
          if (
            this.$store.getters.commande.destinataireClient.typeClient != null
          ) {
            if (
              this.$store.getters.commande.destinataireClient.typeClient !=
                'PART_USAGE_PERSONNEL' &&
              $store.getters.commande.destinataireClient.typeClient !=
                'LIEU_DE_CULTE'
            ) {
              this.noClientJDE =
                this.$store.getters.commande.destinataireClient.noClientJDE
            }
          }
        }
      }
    },
  },

  beforeMount() {
    console.log('Dans le beforeMount de step - destinataire')

    for (let i = 0; i < this.typesClient.length; i++) {
      if (
        this.typesClient[i][0] === 'AGENT_PROMOTIONNEL' ||
        this.typesClient[i][0] === 'TITULAIRE_POUR_REVENTE' ||
        this.typesClient[i][0] === 'PART_USAGE_PERSONNEL' ||
        this.typesClient[i][0] === 'LIEU_DE_CULTE'
      ) {
        this.typeClientsAutorise.push(this.typesClient[i])
      }
    }

    axios
      .get(
        `/agents/obtenirlisteclientagent/${this.$store.getters.agentConnecte.idDemandeur}`
      )
      .then((response) => {
        let resp = response.data

        switch (resp.codeRetour) {
          case 'OK':
            this.listeClientPourAgent = resp.resultat
            this.$store.getters.commande.demandeur =
              this.$store.getters.agentConnecte

            break
          case 'W001':
            break
          default:
            msg = this.$fmtApiErr(resp)
            console.log(msg)
            this.$store.dispatch('afficherError', msg)
            break
        }
      })
      .catch((error) => {
        console.log('error=' + error)
        let texte = ''
        if (error.response) {
          texte = `Status: ${error.response.status} Data: ${error.response.data}`
          console.log(texte)
        } else {
          texte = `Une erreur technique est survenue: ${error.message}`
        }
        this.$store.dispatch('afficherError', texte)
      })
  },

  methods: {
    selectionnerClient() {
      console.log('selectionnerClient ' + this.clientSelect.noClientJDE)

      if (this.clientSelect.noClientJDE != null) {
        this.$store.getters.commande.destinataireClient = {}
        this.$store.getters.commande.commandeAgent = false

        this.noClientJDE = this.clientSelect.noClientJDE
        this.afficherBoiteRechercheClient = true

        if (this.validerAgentNonAutoriseParClient() == false) {
          return
        }

        // aller chercher le idclient de la liste

        for (let i = 0; i < this.listeClientPourAgent.length; i++) {
          if (this.noClientJDE == this.listeClientPourAgent[i].noClientJDE) {
            this.idClientPourRecherche =
              this.listeClientPourAgent[i].idDemandeur
          }
        }

        console.log('le idClient trouvé ' + this.idClientPourRecherche)

        this.rechercherCarnetAdresse()

        // Pour remettre à blanc le select
        this.$nextTick(() => {
          this.clientSelect = null
        })
      } else {
        this.$store.dispatch(
          'afficherWarning',
          'Ce client ne possède pas de numéro de client'
        )
      }
    },

    rechercherClientExisteListeAgent(noClientJDE) {
      console.log('rechercherClientExisteListeAgent ' + noClientJDE)

      this.messageClientExisteListeAgent = ''
      this.clientExistePourAgent = false

      for (let i = 0; i < this.listeClientPourAgent.length; i++) {
        if (noClientJDE == this.listeClientPourAgent[i].noClientJDE) {
          this.clientExistePourAgent = true
        }
      }
      if (this.clientExistePourAgent == true) {
        this.messageAgentNonAutorise =
          'Ce client existe déjà, veuillez le sélectionner dans la liste'
      }
    },

    submit() {
      console.log(
        'submit ' + this.$store.getters.commande.destinataireClient.typeClient
      )
      if (
        this.$store.getters.commande.destinataireClient != null &&
        this.clientExistePourAgent == false
      ) {
        if (
          this.$store.getters.commande.destinataireClient.typeClient ==
            'PART_USAGE_PERSONNEL' ||
          this.$store.getters.commande.destinataireClient.typeClient ==
            'LIEU_DE_CULTE'
        ) {
          this.$store.getters.commande.destinataireClient.nom =
            this.nomParticulier
          this.$store.getters.commande.destinataireClient.nomContact =
            this.nomContactParticulier
          this.$store.getters.commande.destinataireClient.courrielContact =
            this.courrielContactParticulier
          this.$store.getters.commande.destinataireClient.adresse =
            this.adresseParticulier
          this.$store.getters.commande.destinataireClient.ville =
            this.villeParticulier
          this.$store.getters.commande.destinataireClient.codePostal =
            this.codePostalParticulier
          this.$store.getters.commande.destinataireClient.noTelephone =
            this.noTelephoneParticulier
          this.$store.getters.commande.destinataireClient.posteTelephone =
            this.posteTelephoneParticulier
        } else {
          this.$store.getters.commande.destinataireClient.nomContact =
            this.nomContact
          this.$store.getters.commande.destinataireClient.courrielContact =
            this.courrielContact
        }
        if (
          this.$store.getters.commande.destinataireClient.noClientJDE == null
        ) {
          this.champNoClientParticulierLectureSeul = false
        }
      }
    },

    majInfosDestinataire() {
      console.log('majInfosDestinataire ' + this.typeClientSelectionne)

      if (
        this.typeClientSelectionne == 'PART_USAGE_PERSONNEL' ||
        this.typeClientSelectionne == 'LIEU_DE_CULTE'
      ) {
        this.clientExistePourAgent = false
        this.afficherBoiteRechercheClient = false
        this.$store.getters.commande.destinataireClient = {}
        this.$store.getters.commande.destinataireClient.typeClient =
          this.typeClientSelectionne
        this.$store.getters.commande.typeLivraison = null
        this.$store.getters.commande.succursaleLivraisonDemande = null
      } else {
        this.$store.getters.commande.destinataireClient = {}
        this.$store.getters.commande.destinataireClient.typeClient =
          this.typeClientSelectionne
        this.$store.getters.commande.typeLivraison = null
        this.$store.getters.commande.succursaleLivraisonDemande = null
        this.nomContact = null
        this.courrielContact = null
        this.afficherBoiteRechercheClient = true
        this.messageClientExisteListeAgent = ''
      }
    },

    validerAvantRechercheCarnetAdresse() {
      console.log(
        'validerAvantRechercheCarnetAdresse ',
        this.typeClientSelectionne
      )

      if (this.typeClientSelectionne == undefined) {
        this.$store.dispatch(
          'afficherWarning',
          'Vous devez sélectionner un type de client'
        )
        return
      }

      if (
        this.typeClientSelectionne == 'TITULAIRE_POUR_REVENTE' ||
        this.typeClientSelectionne == 'AGENT_PROMOTIONNEL'
      ) {
        this.rechercherClientExisteListeAgent(this.noClientJDE)
        if (this.clientExistePourAgent == true) {
          return
        }
      }

      this.rechercherCarnetAdresse()
    },

    validerAgentNonAutoriseParClient() {
      console.log('validerAgentNonAutoriseParClient')

      this.messageAgentNonAutorise = ''

      // Verifier que le client a autorisé l'agent (par défaut oui mais seul les les TP peuvent retirer l'autorisation)
      var agentAutorise = false
      for (let i = 0; i < this.listeClientPourAgent.length; i++) {
        if (this.noClientJDE == this.listeClientPourAgent[i].noClientJDE) {
          this.idClientPourRecherche = this.listeClientPourAgent[i].idDemandeur
          agentAutorise = true
        }
      }
      if (agentAutorise == false) {
        this.messageAgentNonAutorise =
          "Vous n'avez pas l'autorisation d'effectuer une commande pour le compte de ce client. Veuillez communiquer avec ce dernier pour obtenir l'autorisation."
      }
      return agentAutorise
    },

    validerIsAgentAutorisePourClient() {
      console.log('validerIsAgentAutorisePourClient')
      axios
        .get(
          `/agents/obtenirisagentautorise/${this.$store.getters.commande.demandeur.idDemandeur}/${this.$store.getters.commande.destinataireClient.idDemandeur}`
        )
        .then((response) => {
          const resp = response.data

          switch (resp.codeRetour) {
            case 'OK':
              // La commande est pour le client
              break
            case 'V014':
              this.messageAgentNonAutorise =
                "Vous n'avez pas l'autorisation d'effectuer une commande pour le compte de ce client. Veuillez communiquer avec ce dernier pour obtenir l'autorisation."
              this.majInfosDestinataire()
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    rechercherCarnetAdresse() {
      console.log(
        'rechercherCarnetAdresse pour le idClient : ' +
          this.idClientPourRecherche
      )

      this.messageAgentNonAutorise = null

      if (this.idClientPourRecherche == null) {
        this.idClientPourRecherche = 0
      }

      // On va chercher dans le carnet d'adresse pour information client
      axios
        .get(
          `/clients/rechercherclientcommande/${this.idClientPourRecherche}/${this.noClientJDE}`
        )
        .then((response) => {
          const resp = response.data

          switch (resp.codeRetour) {
            case 'OK':
              this.$store.getters.commande.destinataireClient = resp.resultat
              this.$store.getters.commande.destinataireClient
                .clientListeAgent == true
              this.$store.getters.commande.demandeur =
                this.$store.getters.agentConnecte
              this.nomContact =
                this.$store.getters.commande.destinataireClient.nomContact
              this.courrielContact =
                this.$store.getters.commande.destinataireClient.courrielContact

              if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                'TITULAIRE_POUR_REVENTE'
              ) {
                this.validerIsAgentAutorisePourClient()
              }

              if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'PART_USAGE_PERSONNEL' ||
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'LIEU_DE_CULTE'
              ) {
                this.initialiserInfosParticulier()
              }

              this.noClientJDE = null

              break
            case 'V005':
            case 'X001':
              this.$store.dispatch('afficherInfo', "Ce client n'existe pas")
              break

            case 'V025':
              this.$store.dispatch('afficherError', {
                texte:
                  'Ce client ne peut recevoir de commandes présentement. Pour plus de détails, celui-ci doit communiquer avec notre Service de la comptabilité au 514 254-8686, option 2.',
                duree: 15,
              })
              break

            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })

      this.afficherBoiteRechercheClient = true
      this.noClientJDE = null
    },

    copierPourLuiMeme() {
      console.log('copierPourLuiMeme')
      this.noClientJDE = null

      // La commande est pour l'agent lui-meme
      this.$store.getters.commande.destinataireClient = this.agentConnecte
      this.$store.getters.commande.demandeur = this.agentConnecte
      this.$store.getters.commande.commandeAgent = true
      this.afficherBoiteRechercheClient = false
      this.noClientJDE = this.agentConnecte.noClientJDE
      this.rechercherCarnetAdresse()
    },

    remettreBlancInfosParticulier() {
      nomParticulier = null
      nomContactParticulier = null
      courrielContactParticulier = null
      adresseParticulier = null
      villeParticulier = null
      codePostalParticulier = null
      noTelephoneParticulier = null
      posteTelephoneParticulier = null
    },

    initialiserInfosParticulier() {
      console.log('initialiserInfosParticulier')

      this.nomParticulier = this.$store.getters.commande.destinataireClient.nom
      this.nomContactParticulier =
        this.$store.getters.commande.destinataireClient.nomContact
      this.courrielContactParticulier =
        this.$store.getters.commande.destinataireClient.courrielContact
      this.adresseParticulier =
        this.$store.getters.commande.destinataireClient.adresse
      this.villeParticulier =
        this.$store.getters.commande.destinataireClient.ville
      this.codePostalParticulier =
        this.$store.getters.commande.destinataireClient.codePostal
      this.noTelephoneParticulier =
        this.$store.getters.commande.destinataireClient.noTelephone
      this.posteTelephoneParticulier =
        this.$store.getters.commande.destinataireClient.posteTelephone
      this.champNoClientParticulierLectureSeul = true
    },
  },
}
</script>

<style scoped>
fieldset {
  display: block;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: em;
  border: none;
}

legend {
  margin-left: 20px;
}

div {
  font-size: 13px;
}

.theme--light.v-divider {
  border-color: grey !important;
}

.theme--light.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
